import { Input } from "../../Shared/Input";
import { Button } from "../../Shared/Button";
import "./index.css";

function TrashIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="#FC5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M20.708 6.23975H3.75" stroke="#FC5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="#FC5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

function MultipleChoiceQuestionWidgetContent(props) {
  function onDeleteAnswer({ name, value }) {
    const { widgets, position, answers } = props;
    if (answers.length > 1) {
      const updatedWidgetsArr = [...widgets]
      const widget = updatedWidgetsArr[position - 1];
      widget.answers = answers.filter((ans) => ans.name !== name && ans.value !== value);

      const newAnswersArr = [];
      widget.answers.forEach((ans, idx) => {
        const answer = {
          name: `answer_${idx + 1}`,
          value: ans.value,
        }
        newAnswersArr.push(answer);
      });
      widget.answers = newAnswersArr;
      props.setWidgets(updatedWidgetsArr);
    }
  }

  function onAddAnswer() {
    const { widgets, position } = props;
    const widget = widgets[position - 1];
    const addedAnswer = {
      name: `answer_${widget.answers.length + 1}`,
      value: "",
    };
    const newAnswersArr = [...widget.answers, addedAnswer]
    const updatedArr = [...widgets];
    updatedArr[position - 1].answers = newAnswersArr;
    props.setWidgets(updatedArr);
  }

  function renderAnswers() {
    const { widgets, answers, position } = props;
    return (
      answers.map((ans, idx) => {
        const { name } = ans
        const id = name;
        return (
          <div className="MultiChoiceAnswers" key={idx}>
            <div>
              <Input
                id={id}
                type='text'
                name={id}
                label={id.split("_").join("  ")}
                value={ans.value || ''}
                onChange={(e) => {
                  const updatedArr = [...widgets];
                  updatedArr[position - 1].answers[idx].value = e.target.value;
                  props.setWidgets(updatedArr);
                }}
              />
            </div>
            <div style={{ paddingRight: 10, display: "flex", flexDirection: "row", justifyContent: "flex-end", marginTop: 0 }}>
              <Button
                text="Remove"
                color="white"
                Icon={() => <TrashIcon />}
                onClick={() => onDeleteAnswer(ans)}
              />
            </div>
          </div>
        )
      })
    );
  }

  return (
    <div className="MultipleChoiceQuestionWidgetContent">
      <Input
        id='question'
        type='text'
        label="Question"
        name='question'
        value={props.question || ''}
        onChange={(e) => {
          const updatedArr = [...props.widgets];
          updatedArr[props.position - 1].question = e.target.value;
          props.setWidgets(updatedArr);
        }}
      />

      {renderAnswers()}
      <Button
        type='button'
        text='Add answer'
        onClick={onAddAnswer}
      />
    </div>
  )
}

export default MultipleChoiceQuestionWidgetContent;
